export default __webpack_public_path__ + "static/media/exit-wallet.63e89d7e.svg";